import React from 'react'
import { Pane } from 'evergreen-ui'
const StatusRegister_5 = () => {
  return (
    <Pane
      color="#fff"
      backgroundColor="#b30000ff"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={14}
      fontFamily=""
      margin={0}
      fontWeight={700}
      justifyContent="center"
      alignItems="center"
      display="flex"
      flexDirection="column"
    >
      สละสิทธิ์เข้าศึกษา
    </Pane>

  )
}

export default StatusRegister_5